import React from 'react';
import styled from 'styled-components';
import Button from './Button';
import BigMac from '../assets/img/big-mac-modal.png';

const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10;
`;

const ModalInner = styled.div`
  position: relative;
  width: 323px;
  padding: 24px 24px 168px;
  text-align: center;
  border-radius: 16px;
  border: 2px solid #FFBC0D;
  background-color: #fff;
  background-image: url(${BigMac});
  background-repeat: no-repeat;
  background-size: 323px 158px;
  background-position: bottom center;
  box-sizing: border-box;
  transition: all 400ms cubic-bezier(.47,1.64,.41,.8);
`;

const ModalClose = styled.button`
  position: absolute;
  width: 44px;
  height: 44px;
  top: -30px;
  right: 16px;
  outline: none;
  border: none;
  border-radius: 44px;
  background-color: #E8E8E8;

  &:before {
    content: url('data:image/svg+xml,<svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.55095 13.6122L1.55097 13.6121L1.54696 13.6082C1.35711 13.4226 1.3632 13.0832 1.54216 12.9042L6.92986 7.51653L7.2837 7.16268L6.92957 6.80913L1.54216 1.43051C1.54212 1.43048 1.54209 1.43044 1.54205 1.4304C1.36828 1.25649 1.35954 0.913996 1.55095 0.722581L1.55104 0.722673L1.55889 0.714457C1.73275 0.532513 2.07742 0.532472 2.25877 0.713678C2.25881 0.713716 2.25884 0.713754 2.25888 0.713792L7.6375 6.1012L7.99105 6.45533L8.3449 6.10149L13.7326 0.713792C13.9043 0.542121 14.2317 0.527544 14.4444 0.726543C14.6342 0.920793 14.6271 1.24814 14.4446 1.42647L14.4446 1.42645L14.4405 1.43051L9.06162 6.80942L8.70835 7.16268L9.06133 7.51624L14.4402 12.9039L14.4402 12.904L14.4446 12.9083C14.6201 13.0797 14.6351 13.4039 14.4366 13.6161C14.2417 13.8064 13.9112 13.7996 13.7326 13.6209L8.3449 8.23325L7.99105 7.87941L7.6375 8.23354L2.25888 13.6209C2.085 13.7948 1.74241 13.8036 1.55095 13.6122Z" fill="%232D2D2D" stroke="black"/></svg>');
    position: absolute;
    top: 14px;
    left: 14px;
  }
`;

const ModalTitle = styled.span`
  display: block;
  font-family: 'Speedee Bold';
  font-size: 32px;
  font-weight: bold;
  line-height: 0.95;
  letter-spacing: -0.15px;
  margin-bottom: 8px;
`;

const ModalMessage = styled.p`
  font-size: 15px;
  line-height: 1.25;
  letter-spacing: -0.2px;
  margin: 0 0 24px;
`;

const MessageModal = ({ ...props }) => {
  const { details: { title, message, action: { label, externalUrl, refreshPage } }, setRevealModal } = props;

  const handleClick = () => {
    if (refreshPage) {
      window.location.reload();
    } else {
      if (!!externalUrl) {
        window.location = externalUrl;
      } else {
        setRevealModal(false);
      }
    }
  }
  
  return (
    <ModalWrapper>
      <ModalInner>
        <ModalTitle>{ title }</ModalTitle>
        <ModalMessage>{ message }</ModalMessage>
        <Button onClick={handleClick}>{ label }</Button>
        <ModalClose onClick={() => refreshPage ? window.location.reload() : setRevealModal(false)}/>
      </ModalInner>
    </ModalWrapper>
  )
}

export default MessageModal;